import { ReactiveString } from "../types/request";

export const formatEndpoint = (path: string, urlParams?: ReactiveString[]) => {
	if (!urlParams) return path;
	const formatEndpointString = (value: string) => {
		if (value.startsWith("/")) {
			return value.substring(1);
		}
		return value;
	};

	const extractReactiveString = (urlParam: ReactiveString) => {
		switch (typeof urlParam) {
			case "function":
				return urlParam();
			case "object":
				return urlParam.value;
			case "string":
				return urlParam;
			default:
				return urlParam;
		}
	};

	const paramsIncludeRefValue = urlParams?.some(
		item => typeof item !== "string"
	);
	const endpointString = urlParams
		.map(param => extractReactiveString(param))
		.join("/");
	if (paramsIncludeRefValue) {
		return computed(() => formatEndpointString(`${path}/${endpointString}`));
	} else return formatEndpointString(`${path}/${endpointString}`);
};
